import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import EventsList from '../../components/EventsList/EventsList';
import NotificationsList from '../../components/Notifications/NotificationsList/NotificationsList';
// import OrdersList from '../../components/Shop/Orders/OrdersList';
import PageHeader from '../../components/Layout/PageHeader/PageHeader';
// import OverViewPanels from '../../components/Dashboard/OverViewPanels';

function Dashboard() {
	const user = useSelector(({ user }) => user.data);
	const { userID, firstNames } = user;
	const { t } = useTranslation();
	const partnerID = localStorage.getItem('partnerID');
	return (
		<>
			<PageHeader
				title={`${t('dashboard.header')} ${firstNames}!`}
				subtitle={t('dashboard.subtitle')}
			/>
			<div className="container">
				<div className="row">
					<div className="col-md-8">
						<EventsList
							upcoming
							partnerID={partnerID}
							limit={3}
							dashboard
						/>
					</div>
					<div className="col-md-4">
						<NotificationsList
							partnerID={partnerID}
							userID={userID}
							limit={5}
							dashboard
						/>
					</div>
				</div>
				{/* <div className="row">
					<div className="col-md-12">
						<OrdersList
							limit={10}
							partnerID={partnerID}
						/>
					</div>
				</div> */}
			</div>
		</>
	)
}

export default Dashboard;